<ul>
    <li *ngFor="let item of items; let idx = index">
        <true-bullet (select)="selectItem(item)" [active]="activeItem && item.id == activeItem.id" [complete]="item.value != null" [enabled]="enabled" [first]="idx==0" [last]="idx==items.length-1" [text]="item.description.name.split('###')[0]"></true-bullet>
    </li>
</ul>

